module.exports = __webpack_public_path__ + "static/img/200169.9e329847.png";